import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  private readonly LANGUAGE_COOKIE_NAME = 'preferred_language';
  private readonly COOKIE_EXPIRY_DAYS = 365; // 1 year

  /**
   * Set a cookie with the given name, value, and expiration days
   */
  setCookie(
    name: string,
    value: string,
    days: number = this.COOKIE_EXPIRY_DAYS
  ): void {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    const expiresString = expires.toUTCString();

    document.cookie = `${name}=${value};expires=${expiresString};path=/;SameSite=Lax`;
  }

  /**
   * Get a cookie value by name
   */
  getCookie(name: string): string | null {
    const nameEQ = name + '=';
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1, cookie.length);
      }
      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length, cookie.length);
      }
    }
    return null;
  }

  /**
   * Delete a cookie by name
   */
  deleteCookie(name: string): void {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
  }

  /**
   * Set the preferred language in a cookie
   */
  setLanguage(language: string): void {
    this.setCookie(this.LANGUAGE_COOKIE_NAME, language);
  }

  /**
   * Get the preferred language from cookie
   */
  getLanguage(): string | null {
    return this.getCookie(this.LANGUAGE_COOKIE_NAME);
  }

  /**
   * Check if a language cookie exists
   */
  hasLanguageCookie(): boolean {
    return this.getLanguage() !== null;
  }
}
